"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "wf-options" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    key: 1,
    class: "card-warning"
};
const _hoisted_4 = ["name", "value"];
const _hoisted_5 = {
    key: 0,
    style: { "margin-left": "30px" }
};
const _hoisted_6 = { key: 2 };
const _hoisted_7 = {
    style: { "margin": "5px 30px 10px" },
    class: "wf-action"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_player_input_factory = (0, vue_1.resolveComponent)("player-input-factory");
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.showtitle)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", _hoisted_2, [
                (0, vue_1.createElementVNode)("div", null, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.playerinput.title)), 1)
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.playerinput.warning !== undefined)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", _hoisted_3, [
                (0, vue_1.createElementVNode)("div", null, "(" + (0, vue_1.toDisplayString)(_ctx.$t(_ctx.playerinput.warning)) + ")", 1)
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.displayedOptions, (option, idx) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", { key: idx }, [
                (0, vue_1.createElementVNode)("label", {
                    class: "form-radio",
                    ref_for: true,
                    ref: "optionLabels"
                }, [
                    (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedOption) = $event)),
                        type: "radio",
                        name: _ctx.radioElementName,
                        value: option
                    }, null, 8, _hoisted_4), [
                        [vue_1.vModelRadio, _ctx.selectedOption]
                    ]),
                    _cache[1] || (_cache[1] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                    (0, vue_1.createElementVNode)("span", null, (0, vue_1.toDisplayString)(_ctx.$t(option.title)), 1)
                ], 512),
                (_ctx.selectedIdx === idx)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_5, [
                        (0, vue_1.createVNode)(_component_player_input_factory, {
                            ref_for: true,
                            ref: "inputfactory",
                            players: _ctx.players,
                            playerView: _ctx.playerView,
                            playerinput: option,
                            onsave: _ctx.playerFactorySaved(idx),
                            showsave: false,
                            showtitle: false
                        }, null, 8, ["players", "playerView", "playerinput", "onsave"])
                    ]))
                    : (0, vue_1.createCommentVNode)("", true)
            ]));
        }), 128)),
        (_ctx.showsave && _ctx.selectedOption)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_6, [
                (0, vue_1.createElementVNode)("div", _hoisted_7, [
                    (0, vue_1.createVNode)(_component_AppButton, {
                        title: _ctx.$t(_ctx.selectedOption.buttonLabel),
                        type: "submit",
                        size: "normal",
                        onClick: _ctx.saveData
                    }, null, 8, ["title", "onClick"])
                ])
            ]))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
